import { DefaultService } from '@/services/DefaultService';

export default class ProAtendimentoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/atendimento.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getFiltros() {
        return this._http.get(`${this._env}/report-promotor/services`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    saveFiltros(filtros) {
        return this._http
            .post(`${this._env}/report-promotor/services`, filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getCSV(filtros) {
        return this._http
            .post(`${this._env}/report-promotor/services/csv`, filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getDetail(idatendimento) {
        return this._http
            .get(`${this._env}/report-promotor/services/detailed/${idatendimento}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
    findDadosClienteByIdLps(idatendimentolps) {
        return this._http
            .get(
                `${this._env}/atendimentolps/getdadosclientebyid/${idatendimentolps}.json`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getDetailForm(idatendimento, idformulario) {
        return this._http
            .get(
                `${
                    this._env
                }/report-promotor/services/detailed/${idatendimento}/form/${idformulario}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllByContratoData(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/atendimento/by-contrato-data.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllByLpsData(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/atendimento/by-lps-data.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    removeFoto(foto, context) {
        return this._http
            .post(
                encodeURI(`${this._env}/report-promotor/services/photo/${context}/inactive`),
                foto,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
    
    save(file, context, foto) {
        const unifiedData = new FormData();

        unifiedData.append("file", file);
        unifiedData.append("foto", new Blob([JSON.stringify(foto)],
        {
            type: "application/json"
        }));
        unifiedData.append("foto", foto)

        const requestOptions = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: unifiedData
        }

        delete requestOptions.headers["Content-Type"];
        
		return this._http.post(`${this._env}/report-promotor/services/photo/${context}/update`, unifiedData, requestOptions).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}
